var Curriculog = Curriculog || {};

Curriculog.DropdownFilterView = (function ($, _, Backbone, DropdownFilterView) {

    DropdownFilterView = Curriculog.CurriculogView.extend({
        el: function () {
            return this.options.el || document.getElementById(this.id);
        },

        initialize: function (options) {
            // View default properties setup
            this.id = options.id || '';
            this.collection = options.collection || {};

            // View custom properties setup
            this.params = options.params || {};
            this.filterParam = options.filterParam || this.attributes['data-filterParam'];
            this.firstOption = options.firstOption || 'All Options';
            this.noAvailableOptionsMessage = options.noAvailableOptionsMessage || 'No Options Available';
            // Allow the filter to be 'disabled' so that a user cannot go from one tab that has current steps
            // to another tab that that the filter is supposed to be disabled on but yet the filter
            // populates because the collection is still available from the previous tab - TP #18438
            this.disabled = options.disabled || true;
        },

        get: function (options) {
            if (options && options.disabled) {
                this.disabled = true;

                this.buildDropdown();
            } else {
                var that = this,
                    value = this.getSelectedValue(),
                    xhr = {};

                xhr = this.collection.fetch();

                return $.when(xhr).then(
                    // Success response
                    function () {
                        // Allow the filter to have options and be enabled
                        that.disabled = false;

                        that.buildDropdown(that.collection, value);

                        // Return some data in order to correctly call
                        // the dependency ajax call
                        if (options) {
                            return {
                                that: options.that,
                                currentFilter: options.currentFilter,
                            };
                        }
                    },
                    // Error response
                    function () {
                        that.disabled = true;

                        that.buildDropdown();

                        // Return some data in order to correctly call
                        // the dependency ajax call
                        if (options) {
                            return {
                                that: options.that,
                                currentFilter: options.currentFilter,
                            };
                        }
                    }
                );
            }
        },

        getSelectedValue: function () {
            var param = this.params.queryParams.get(this.filterParam);

            return param ? param : '';
        },

        getNewSelectedValue: function () {
            return this.$el.val();
        },

        set: function () {
            var value = this.$el.val() ? this.$el.val() : 0;

            this.params.queryParams.set(this.filterParam, value);
        },

        buildDropdown: function (collection, value) {
            var attributes = {};

            this.getDropdownAttributes(attributes);

            var dropdown = new Curriculog.DropdownView({
                collection: collection ? collection : {},
                attributes: attributes,
                firstOption: this.firstOption,
                noAvailableOptionsMessage: this.noAvailableOptionsMessage,
                selectedValue: (isNaN(value) ? value : parseInt(value)),
            });

            this.replaceDropdownDomElement(dropdown, value);
        },

        getDropdownAttributes: function (attributes) {
             $.each(this.$el[0].attributes, function (index, attr) {
                attributes[attr.name] = attr.value;
            });

            // Add class after first render of dropdown so that we don't have to run
            // an ajax call to grab the dataset again
            attributes.class += ' render-finished';
        },

        replaceDropdownDomElement: function (view, value) {
            // Allow Screen Reader to Focus on Element To Replace Old, Empty Element
            view.$el.attr('tabindex', 0);

            // Destroy the old empty element and replace it with the Backbone built select with options dynamically populated
            this.$el.selectWoo('destroy').replaceWith(view.$el);

            // Set the new element as the Backbone View element
            this.setElement(view.$el);

            // Apply the select2 plugin to the new element
            this.$el.selectWoo({
                theme: 'curriculog'
            });

            var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
						this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );

            if (value) {
                // Trigger the select change event to update the 'selected' option
                this.$el.trigger('change');
            }
        },
    });

    return DropdownFilterView;

})($, _, Backbone, Curriculog.DropdownFilterView || {});
